import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import Hashids from 'hashids';
import axios from 'axios';
import LoaderBTN from '../components/LoaderBTN';
import { BASE_URL, getCurrentSurvey, getIPQualityCheck } from '../Utlils';
import Skeleton from '../components/Skeleton';
import useQualificationCache from '../hooks/useQualificationCache';
const hashids = new Hashids('My Project');
var id = hashids.encodeHex('507f1f77bcf86cd799439011');
var hex = hashids.decodeHex(id);
const QUALIFICATION_CACHE_MONTHS =
  Number(process.env.REACT_APP_QUALIFICATION_CACHE_MONTHS) === 6 ? 6 : 3;

const lucidId = process.env.REACT_APP_LUCID_ID;
const acutusId = process.env.REACT_APP_ACUTUS_ID;
const tolunaId = process.env.REACT_APP_Toluna_Survey_ID;
const theoremReachId = process.env.REACT_APP_THEOREM_REACH_ClIENT_ID;
const zampliaId = process.env.REACT_APP_ZAMPLIA_ID;
const pureSpectrumId = process.env.REACT_APP_PURE_SPECTRUM_ID;

const buildCachedQuestionResponse = (element, userResponse) => {
  const fullQuestion = element?.question;

  const response = {
    question_id: element?._id,
    question_name: fullQuestion?.questionName,
    user_response: userResponse,
  };

  const createdBy = fullQuestion?.createdBy;
  const clientQuestionID = fullQuestion?.clientQuestionID || null;
  const displayOptions = element?.displayOptions || [];

  const getOptionIndex = (answer) => {
    return displayOptions.findIndex(
      (option) => String(option).trim() === String(answer).trim(),
    );
  };

  let providerMappingValid = true;

  // TheoremReach
  if (createdBy === theoremReachId && clientQuestionID) {
    const answers = Array.isArray(userResponse) ? userResponse : [userResponse];

    const keys = answers
      .map((answer) => {
        const index = getOptionIndex(answer);
        const answerId = fullQuestion?.optionIds?.[index];

        if (index === -1 || answerId == null) {
          providerMappingValid = false;
          return null;
        }

        return `question_${clientQuestionID}[]=${answerId}`;
      })
      .filter(Boolean);

    response.TRKey = keys.length ? keys.join('&') : null;
  }

  // Zamplia
  if (createdBy === zampliaId && clientQuestionID) {
    const answers = Array.isArray(userResponse) ? userResponse : [userResponse];

    const answerIds = answers
      .map((answer) => {
        const index = getOptionIndex(answer);
        const answerId = fullQuestion?.answerIds?.[index];

        if (index === -1 || answerId == null) {
          providerMappingValid = false;
          return null;
        }

        return String(answerId);
      })
      .filter(Boolean);

    response.ZAMKey = answerIds.length
      ? `q${clientQuestionID}=${answerIds.join(',')}`
      : null;
  }

  // Pure Spectrum
  if (createdBy === pureSpectrumId && clientQuestionID) {
    const answers = Array.isArray(userResponse) ? userResponse : [userResponse];
    const questionType = fullQuestion?.questionType;
    if (
      questionType === 'Text - Open-end' ||
      questionType === 'Numeric - Open-end'
    ) {
      const value = String(userResponse ?? '').trim();

      if (value) {
        response.PSKey = `${clientQuestionID}=${value}`;
      }
    } else {
      const answerIds = answers
        .map((answer) => {
          const index = getOptionIndex(answer);
          const answerId = fullQuestion?.answerIds?.[index];
          if (index === -1 || answerId == null) {
            providerMappingValid = false;
            return null;
          }
          return String(answerId);
        })
        .filter(Boolean);

      response.PSKey = answerIds.length
        ? `${clientQuestionID}=${answerIds.join(',')}`
        : null;
    }
  }

  return {
    response,
    providerMappingValid,
  };
};

const TOLUNA_QUESTION_IDS = {
  birthDate: '6968c238040e94e8df270cb7',
  postalCode: '6adeee8da726fae34d2b2612',
  gender: 1001007,
};
const SurveyQualification = () => {
  const [qualificationConfig, setQualificationConfig] = useState({
    loading: true,
    error: false,
  });
  const [survey, setSurvey] = useState({});
  const { sId, supId, orgId } = useParams();
  const { getQualification, saveQualification } = useQualificationCache({
    maxAgeMonths: QUALIFICATION_CACHE_MONTHS,
  });
  const [resumingQualifications, setResumingQualifications] = useState(true);
  const resumeStartedRef = useRef(null);
  const surveyID = sId;

  const gamma = localStorage.getItem('gamma');
  let sessionId = localStorage.getItem('session_id');
  let src = localStorage.getItem('srcID');
  let ref_id = localStorage.getItem('ref_id');
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [presecreenQuestions, setPresecreenQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  let [questionsData, setQuestionsData] = useState([]);
  const [multiResponse, setMultiResponse] = useState([]);
  const [hiddenPrescreeningQuestions, setHiddenPrescreeningQuestions] =
    useState([]);
  const [lucidQuestions, setLucidQuestions] = useState([]);
  const [lucidLoading, setLucidLoading] = useState(false);
  const [lucidError, setLucidError] = useState(false);
  // !----------functions---------------------

  const getQualificationCacheId = (element) => {
    const questionId = element?.question?._id;
    return questionId ? String(questionId) : null;
  };

  const getSurvey = async () => {
    try {
      setQualificationConfig({
        loading: true,
        error: false,
      });
      const { data } = await axios.get(`${BASE_URL}/survey/one?id=${surveyID}`);

      setSurvey(data);
    } catch (error) {
      console.error('Unable to get Survey details:', error);

      setSurvey({});
      setQualificationConfig({
        loading: false,
        error: true,
      });
      setResumingQualifications(false);
    }
  };
  const handleQuestionData = (qId, name, e, fullQuestion = null) => {
    let newArr = [...questionsData]?.filter(
      (data) => data?.question_id !== qId,
    );
    const createdBy = fullQuestion?.createdBy;
    const isTRquestion = createdBy === theoremReachId;
    const isZampliaquestion = createdBy === zampliaId;
    const isPureSpectrumQuestion = createdBy === pureSpectrumId;
    const clientQuestionID = fullQuestion?.clientQuestionID || null;
    // console.log("clientQuestionID=>", clientQuestionID);

    newArr.push({
      question_id: qId,
      question_name: name,
      user_response: e.target.value,
      // fullQuestion: fullQuestion || null,
      TRKey:
        isTRquestion && clientQuestionID
          ? `question_${clientQuestionID}[]=${e.target.value}`
          : null,
      ZAMKey:
        isZampliaquestion && clientQuestionID
          ? `q${clientQuestionID}=${e.target.value}`
          : null,

      PSKey:
        isPureSpectrumQuestion && clientQuestionID
          ? `${clientQuestionID}=${e.target.value}`
          : null,
    });
    setQuestionsData(newArr);
  };
  const handlePrescreenEnter = (e) => {
    e.preventDefault();
    // console.log("enter called");
    // if (presecreenQuestions?.length - 1 !== currentIndex) {
    //   checkIsAnswerCorrect(e, null, "plusOne");
    // } else {
    //   checkIsAnswerCorrect(e, "lastQuestion");
    // }
  };
  const handleMultiResposnseChange = (e, id, option, index) => {
    if (e.target.checked) {
      let singArr = questionsData?.filter((data) => data.questionId === id);
      // console.log("singleArr", singArr);
      // console.log("includes", singArr[0].response.includes(index));
      if (singArr?.length) {
        if (!singArr[0].response.includes(index)) {
          singArr[0]?.response?.push(index);
        }
      } else {
        singArr = [{ questionId: id, response: [index] }];
      }
      let newArr = [...questionsData, ...singArr];
      setQuestionsData(
        [...new Set(newArr?.map(JSON.stringify))].map(JSON.parse),
      );
    } else {
      let singArr = questionsData?.filter((data) => data.questionId === id);
      let filtereRes = singArr[0]?.response?.filter((data) => data !== index);
      let filteredArray = questionsData?.filter(
        (data) => data.questionId !== id,
      );
      let finalArray = [
        ...filteredArray,
        { questionId: id, response: filtereRes },
      ];
      setQuestionsData(
        [...new Set(finalArray?.map(JSON.stringify))].map(JSON.parse),
      );
    }
  };
  let hideQuestions = ['MS_is_tablet', 'MS_is_mobile'];
  const getLucidQuestions = async () => {
    try {
      setLucidLoading(true);
      setLucidError(false);
      const { data: lucidData } = await axios.get(
        `${BASE_URL}/session/${surveyID}/lucid-qualifications`,
      );

      setLucidQuestions(lucidData?.data || []);
    } catch (error) {
      console.error('Unable to get Lucid qualifications:', error);
      setLucidQuestions([]);
      setLucidError(true);
    } finally {
      setLucidLoading(false);
    }
  };
  const getTableQualification = async (e) => {
    try {
      setQualificationConfig({
        loading: true,
        error: false,
      });

      setPresecreenQuestions([]);

      let data = (
        await axios.get(`${BASE_URL}/session/${survey?._id}/qualifications`)
      ).data;

      const visibleQuestions = data?.filter(
        (d) =>
          !hideQuestions?.includes(d?.question?.questionName?.trim()) &&
          d?.status,
      );

      const hiddenQuestions = data?.filter(
        (d) =>
          hideQuestions?.includes(d?.question?.questionName?.trim()) &&
          d?.status,
      );

      setPresecreenQuestions(visibleQuestions);
      setHiddenPrescreeningQuestions(hiddenQuestions);

      setQualificationConfig({
        loading: false,
        error: false,
      });
    } catch (error) {
      console.error('Unable to get qualification:', error);

      setQualificationConfig({
        loading: false,
        error: true,
      });

      setResumingQualifications(false);
    }
  };
  const terminateQualification = async ({ reason, responses }) => {
    const isQuotaFull = reason === 'QUOTA_FULL';
    const miratsStatus = isQuotaFull ? 40 : 23;
    const endStatus = isQuotaFull ? 40 : 20;

    try {
      await axios.put(`${BASE_URL}/session?id=${sessionId}`, {
        responses,
        client_status: -1,
        mirats_status: miratsStatus,
      });

      window.location.href =
        `${window.location.origin}` +
        `/7e08091a73b14e034889265e41ba796f91c766ad/` +
        `${encodeURIComponent(ref_id)}/` +
        `${endStatus}`;
    } catch (error) {
      console.error('Unable to terminate qualification:', error);
      setSpinnerLoader(false);
      setResumingQualifications(false);
    }
  };
  const validateQualificationAnswer = async (questionData, currentData) => {
    const questionType = questionData?.question?.questionType;

    const userResponse = currentData?.user_response;

    if (questionType === 'Multi Punch') {
      const responses = Array.isArray(userResponse) ? userResponse : [];

      const isCorrect = responses?.some((answer) =>
        questionData?.validOptions?.some(
          (validOption) => validOption == answer,
        ),
      );

      if (!isCorrect) {
        return {
          passed: false,
          reason: 'INCORRECT',
        };
      }

      // Check quota
      for (const answer of responses) {
        if (questionData?.quotas?.[answer]) {
          const { data: isQuotaFull } = await axios.post(
            `${BASE_URL}/session/qualification-quota/${surveyID}/${questionData?._id}`,
            {
              userRes: answer,
            },
          );

          if (isQuotaFull) {
            return {
              passed: false,
              reason: 'QUOTA_FULL',
            };
          }
        }
      }

      return {
        passed: true,
      };
    }

    if (questionType === 'Single Punch' || questionType === 'Dummy') {
      const isCorrect = questionData?.validOptions?.includes(
        userResponse?.trim(),
      );

      if (!isCorrect) {
        return {
          passed: false,
          reason: 'INCORRECT',
        };
      }

      if (questionData?.quotas?.[userResponse]) {
        const { data: isQuotaFull } = await axios.post(
          `${BASE_URL}/session/qualification-quota/${surveyID}/${questionData?._id}`,
          {
            userRes: userResponse,
          },
        );

        if (isQuotaFull) {
          return {
            passed: false,
            reason: 'QUOTA_FULL',
          };
        }
      }

      return {
        passed: true,
      };
    }

    if (questionType === 'Numeric - Open-end') {
      if (survey?.createdBy === lucidId && questionData?.preCodes?.length) {
        const isCorrect = questionData.preCodes.includes(
          String(userResponse).trim(),
        );

        return {
          passed: isCorrect,
          reason: isCorrect ? null : 'INCORRECT',
        };
      }
      if (
        survey?.createdBy === tolunaId &&
        Number(questionData?.tolunaQuestionID) === 1001538
      ) {
        const value = String(userResponse ?? '').trim();
        const age = Number(value);

        const isCorrect =
          /^\d+$/.test(value) &&
          Number.isSafeInteger(age) &&
          questionData.validOptions?.some(
            ({ from, to }) => age >= Number(from) && age <= Number(to),
          );

        return {
          passed: Boolean(isCorrect),
          reason: isCorrect ? null : 'INCORRECT',
        };
      }

      const numericValue = Number(userResponse);

      const from = Number(questionData?.validOptions?.[0]?.from);

      const to = Number(questionData?.validOptions?.[0]?.to);

      const isCorrect = numericValue >= from && numericValue <= to;

      return {
        passed: isCorrect,
        reason: isCorrect ? null : 'INCORRECT',
      };
    }

    return {
      passed: true,
    };
  };
  const submitResponse = async (
    responses = questionsData,
    responseToCache = null,
  ) => {
    try {
      // console.log('submitting', responses);
      const { data } = await axios.put(`${BASE_URL}/session?id=${sessionId}`, {
        responses,
        client_status: 1,
        mirats_status: 3,
        src,
      });
      if (responseToCache) {
        try {
          await saveQualification(
            responseToCache.questionId,
            responseToCache.response,
          );
        } catch (error) {
          console.error('Unable to save final qualification:', error);
        }
      }
      const currentSurvey = await getCurrentSurvey(surveyID);
      const url = currentSurvey?.setup?.liveUrl;
      const testURL = currentSurvey?.setup?.testUrl;
      const refId = data?.ref_id ?? '';

      if (currentSurvey?.createdBy === tolunaId) {
        await handleTolunaRedirect({
          surveyId: currentSurvey?._id,
          refId: data?.ref_id,
          responses,
        });
        return;
      }

      if (currentSurvey?.createdBy === theoremReachId) {
        await handleTheoremReachRedirect({
          url,
          surveyId: currentSurvey?._id,
          refId: data?.ref_id,
          responses,
        });
        return;
      }

      if (currentSurvey?.createdBy === zampliaId) {
        await handleZampliaRedirect({
          url,
          surveyId: currentSurvey?._id,
          refId: data?.ref_id,
          responses,
        });

        return;
      }
      if (currentSurvey?.createdBy === pureSpectrumId) {
        await handlePureSpectrumRedirect({
          surveyId: currentSurvey?._id,
          refId: data?.ref_id,
          responses,
        });

        return;
      }

      if (gamma !== 'alpha') {
        if (!url) {
          console.log('live url is not set');
          setSpinnerLoader(false);
          setResumingQualifications(false);
          return;
        }

        const modifiedUrl = url.replace(
          /\[%rid%\]|\[#vq_tid#\]|\[#vq_tuid#\]/g,
          refId,
        );

        if (currentSurvey?.createdBy === lucidId) {
          const newLucidUrl = await handleLucidRedirect(modifiedUrl, responses);

          if (newLucidUrl?.success) {
            window.location.href = newLucidUrl?.redirectURL;
          } else {
            console.log('Unable to redirect');
            setSpinnerLoader(false);
            setResumingQualifications(false);
          }
        } else if (currentSurvey?.createdBy === acutusId) {
          const newAcutusURL = await handleAcutusRedirect(modifiedUrl, refId);

          if (newAcutusURL?.success) {
            window.location.href = newAcutusURL?.redirectURL;
          } else {
            console.log('Unable to redirect');
            setSpinnerLoader(false);
            setResumingQualifications(false);
          }
        } else {
          window.location.href = modifiedUrl;
        }

        return;
      }
      if (!testURL) {
        console.log('Test url is not set');
        setSpinnerLoader(false);
        setResumingQualifications(false);
        return;
      }

      const modifiedUrl = testURL.replace(
        /\[%rid%\]|\[#vq_tid#\]|\[#vq_tuid#\]/g,
        refId,
      );
      if (currentSurvey?.createdBy === lucidId) {
        const newLucidUrl = await handleLucidRedirect(modifiedUrl, responses);

        if (newLucidUrl?.success) {
          window.location.href = newLucidUrl?.redirectURL;
        } else {
          console.log('Unable to redirect');
          setSpinnerLoader(false);
          setResumingQualifications(false);
        }
      } else if (currentSurvey?.createdBy === acutusId) {
        const newAcutusURL = await handleAcutusRedirect(modifiedUrl, refId);

        if (newAcutusURL?.success) {
          window.location.href = newAcutusURL?.redirectURL;
        } else {
          console.log('Unable to redirect');
          setSpinnerLoader(false);
          setResumingQualifications(false);
        }
      } else {
        window.location.href = modifiedUrl;
      }
    } catch (error) {
      console.error(error);
      setSpinnerLoader(false);
      setResumingQualifications(false);
    }
  };

  //   !-----------------------UseEffects-----------------
  const calcProg = presecreenQuestions?.length
    ? ((currentIndex + 1) / presecreenQuestions?.length) * 100
    : 20;

  useEffect(() => {
    if (!surveyID) {
      return;
    }
    if (!survey?._id) {
      getSurvey();
      return;
    }
    getTableQualification();
    if (survey?.createdBy === lucidId) {
      getLucidQuestions();
    } else {
      setLucidQuestions([]);
      setLucidLoading(false);
    }
  }, [surveyID, survey?._id, survey?.createdBy]);

  useEffect(() => {
    if (qualificationConfig.loading || qualificationConfig.error) {
      return;
    }

    if (!survey?._id) {
      return;
    }

    if (survey?.createdBy === lucidId) {
      if (lucidLoading || lucidError) {
        return;
      }
    }

    if (resumeStartedRef.current === surveyID) {
      return;
    }

    resumeStartedRef.current = surveyID;

    resumeQualifications(0, []);
  }, [
    qualificationConfig.loading,
    qualificationConfig.error,
    survey?._id,
    survey?.createdBy,
    lucidLoading,
    lucidError,
    surveyID,
  ]);

  const userAgent = navigator.userAgent;
  const getPlatform = () => {
    if (/Android/i.test(userAgent)) return 'Android';
    if (/iPhone|iPod/i.test(userAgent)) return 'iOS';
    if (/iPad/i.test(userAgent)) return 'iPad';
    return 'Unknown';
  };
  const deviceType = () => {
    const platform = getPlatform();
    if (platform === 'Android' || platform === 'iOS' || platform === 'iPad') {
      if (platform === 'iPad' || userAgent.includes('Tablet')) {
        return 'Tablet';
      }
      return 'Mobile';
    }
    return 'PC';
  };
  const handleLucidRedirect = async (url, responses = questionsData) => {
    try {
      let questionResStr = '';
      for (let question of presecreenQuestions) {
        let response = responses?.find((d) => d?.question_id == question?._id);
        let lucidQuestionData = lucidQuestions?.find(
          (d) =>
            d?.QuestionID == Number(question?.question?.clientQuestionID) &&
            d?.countryCode == Number(question?.question?.countryCode),
        );
        if (response && lucidQuestionData) {
          if (question?.question?.questionType?.endsWith('end')) {
            questionResStr += `&${question?.question?.clientQuestionID}=${response?.user_response}`;
          } else {
            if (
              question?.question?.questionType === 'Single Punch' ||
              question?.question?.questionType === 'Dummy'
            ) {
              let singlePunchRes = lucidQuestionData?.QuestionOptions?.filter(
                (d) => d?.OptionText?.trim() == response?.user_response?.trim(),
              );
              if (singlePunchRes?.length) {
                questionResStr += `&${question?.question?.clientQuestionID}=${singlePunchRes?.[0]?.Precode}`;
              }
            } else {
              response?.user_response?.forEach((d) => {
                let multiLucidQuestion =
                  lucidQuestionData?.QuestionOptions?.filter(
                    (op) => op?.OptionText?.trim() === d?.trim(),
                  );

                if (multiLucidQuestion?.length) {
                  questionResStr += `&${question?.question?.clientQuestionID}=${multiLucidQuestion?.[0]?.Precode}`;
                }
              });
            }
          }
        }
      }
      if (hiddenPrescreeningQuestions?.length) {
        let device = deviceType();
        for (let hiddenQuestion of hiddenPrescreeningQuestions) {
          if (hiddenQuestion?.question?.questionName === 'MS_is_mobile') {
            if (device === 'Mobile') {
              questionResStr += `&${hiddenQuestion?.question?.clientQuestionID}=true`;
            } else {
              questionResStr += `&${hiddenQuestion?.question?.clientQuestionID}=false`;
            }
          } else if (
            hiddenQuestion?.question?.questionName === 'MS_is_tablet'
          ) {
            if (device === 'Tablet') {
              questionResStr += `&${hiddenQuestion?.question?.clientQuestionID}=true`;
            } else {
              questionResStr += `&${hiddenQuestion?.question?.clientQuestionID}=false`;
            }
          }
        }
      }
      let urlBeforeHashing = url + questionResStr;
      let { data: lucidRedirects } = await axios.post(
        `${BASE_URL}/redirect/get-lucid-redirect`,
        {
          baseUrl: urlBeforeHashing,
        },
      );
      return {
        success: true,
        profilingParams: urlBeforeHashing,
        redirectURL: lucidRedirects?.signedUrl,
      };
    } catch (error) {
      console.log('Unable to perform lucid redirects', error);
      return { success: false };
    }
  };
  const handleAcutusRedirect = async (url, refId) => {
    try {
      let urlBeforeHashing = url;
      let { data: lucidRedirects } = await axios.post(
        `${BASE_URL}/redirect/get-acutus-redirect`,
        {
          baseUrl: urlBeforeHashing,
          sessionID: sessionId,
          refId,
        },
      );
      return {
        success: true,
        profilingParams: urlBeforeHashing,
        redirectURL: lucidRedirects?.url,
      };
    } catch (error) {
      return { success: false };
    }
  };
  const handleTolunaRedirect2 = async ({
    surveyId,
    refId,
    responses = questionsData,
  }) => {
    try {
      // console.log('handleTolunaRedirect=>');
      const dateQuestion = responses[responses?.length - 1];
      const genderQuestion = responses[responses?.length - 2];
      const userResponse = dateQuestion?.user_response || '12/01/1970';
      // console.log({ userResponse, dateQuestion, genderQuestion });
      //check if userResponse is in dd/mm/yyyy format
      const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
      if (!regex.test(userResponse)) {
        alert('Please enter date in dd/mm/yyyy format eg:20/01/1970');
        setSpinnerLoader(false);
        setResumingQualifications(false);
        return;
      } else {
        const [day, month, year] = String(userResponse)?.split('/');
        let gender = genderQuestion?.user_response;
        const genderMap = {
          Male: 2000247,
          Female: 2000246,
        };
        const tolunaRedirectBody = {
          surveyId,
          refId,
          BirthDate: `${month}/${day}/${year}`,
          GenderID: genderMap[gender] || 2000247,
        };
        // console.log('tolunaRedirectBody', tolunaRedirectBody);
        const { data: tolunaRedirects } = await axios.post(
          `${BASE_URL}/redirect/get-toluna-redirect`,
          tolunaRedirectBody,
        );
        // console.log('tolunaRedirects=>', tolunaRedirects);

        if (tolunaRedirects?.data?.URL) {
          window.location.href = tolunaRedirects?.data?.URL;
          return;
        } else if (!tolunaRedirects?.securityCheck) {
          window.location.href = `${
            window?.location?.origin
          }/7e08091a73b14e034889265e41ba796f91c766ad/${encodeURIComponent(
            ref_id,
          )}/30`;
          return;
        } else {
          window.location.href = '/error/429';
        }
      }
    } catch (error) {
      console.log('Unable to perform toluna redirects', error);
      await axios
        .put(`${BASE_URL}/session?id=${sessionId}`, {
          responses,
          client_status: -1,
          mirats_status: 30,
        })
        .then((data) => {
          // console.log(data);
          window.location.href = `${
            window.location.origin
          }/7e08091a73b14e034889265e41ba796f91c766ad/${encodeURIComponent(
            ref_id,
          )}/40`;
        })
        .catch((er) => console.log(er));
    }
  };
  const findTolunaQuestionIndex = ({ field, questionId }) => {
    const normalize = (value) =>
      String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[\s_-]/g, '');

    return presecreenQuestions.findIndex((q) => {
      if (questionId && String(q._id) === String(questionId)) {
        return true;
      }

      if (q.tolunaField === field) {
        return true;
      }

      const originalId = String(q.question?._id || '');
      const name = normalize(q.question?.questionName);

      if (field === 'birthDate') {
        return (
          originalId === TOLUNA_QUESTION_IDS.birthDate ||
          ['dob', 'dateofbirth', 'birthdate'].includes(name)
        );
      }

      if (field === 'postalCode') {
        return (
          originalId === TOLUNA_QUESTION_IDS.postalCode ||
          ['postalcode', 'postcode', 'zipcode', 'zip'].includes(name)
        );
      }

      if (field === 'gender') {
        return (
          Number(q.question?.clientQuestionID) === TOLUNA_QUESTION_IDS.gender ||
          name === 'gender'
        );
      }

      return false;
    });
  };
  const handleTolunaRedirect = async ({
    surveyId,
    refId,
    responses = questionsData,
  }) => {
    try {
      const { data: tolunaRedirects } = await axios.post(
        `${BASE_URL}/redirect/get-toluna-redirect`,
        {
          surveyId,
          refId,
        },
      );

      if (tolunaRedirects?.data?.URL) {
        window.location.href = tolunaRedirects.data.URL;
        return;
      }

      if (tolunaRedirects?.securityCheck === false) {
        window.location.href =
          `${window.location.origin}` +
          `/7e08091a73b14e034889265e41ba796f91c766ad/` +
          `${encodeURIComponent(refId)}/30`;
        return;
      }

      throw new Error('Toluna redirect URL not available');
    } catch (error) {
      const apiError = error?.response?.data;

      if (
        error?.response?.status === 422 &&
        apiError?.code === 'INVALID_QUALIFICATION'
      ) {
        const questionIndex = findTolunaQuestionIndex(apiError);

        if (questionIndex !== -1) {
          const question = presecreenQuestions[questionIndex];

          const invalidIds = new Set(
            [apiError.questionId, question?._id].filter(Boolean).map(String),
          );

          setQuestionsData((previous) =>
            previous.filter(
              (response) => !invalidIds.has(String(response.question_id)),
            ),
          );
          setCurrentIndex(questionIndex);
          setSpinnerLoader(false);
          setResumingQualifications(false);

          alert(apiError.message || 'Please correct your answer.');
          return;
        }

        alert(
          'Unable to locate the required qualification. Please refresh the survey.',
        );

        setSpinnerLoader(false);
        setResumingQualifications(false);
        return;
      }

      if (
        error?.response?.status === 409 &&
        (apiError?.code === 'MISSING_QUALIFICATION' ||
          apiError?.code === 'SURVEY_CONFIGURATION_ERROR')
      ) {
        console.error('Toluna configuration issue:', apiError);

        alert('This survey has a configuration issue. Please contact support.');

        setSpinnerLoader(false);
        setResumingQualifications(false);
        return;
      }

      // Other failures retain your existing termination behavior.
      console.error('Unable to perform Toluna redirect:', error);

      try {
        await axios.put(`${BASE_URL}/session?id=${sessionId}`, {
          responses,
          client_status: -1,
          mirats_status: 30,
        });
      } catch (sessionError) {
        console.error('Unable to update session:', sessionError);
      }

      window.location.href =
        `${window.location.origin}` +
        `/7e08091a73b14e034889265e41ba796f91c766ad/` +
        `${encodeURIComponent(refId)}/40`;
    }
  };
  // console.log('questionsData=>', questionsData);

  const handleTheoremReachRedirect = async ({
    url,
    surveyId,
    refId,
    responses = questionsData,
  }) => {
    try {
      const allDemographicQuery = responses
        ?.map((item) => item?.TRKey)
        ?.filter(Boolean)
        .join('&');
      const finalURL = `${url}&${allDemographicQuery}`;
      let body = {
        baseUrl: finalURL,
        sessionID: sessionId,
        surveyId,
        refId,
      };
      // console.log("body=>", body);
      const { data: theoremReachRedirects } = await axios.post(
        `${BASE_URL}/redirect/get-theorem-reach-client-redirect`,
        body,
      );
      // console.log("theoremReachRedirects=>", theoremReachRedirects);

      const redirectToURL = theoremReachRedirects?.url;
      if (!redirectToURL)
        throw new Error('Theorem reach redirect URL is not available');
      window.location.href = redirectToURL;
      return;
    } catch (error) {
      console.log('Unable to perform theoremReachRedirect redirects', error);
      await axios
        .put(`${BASE_URL}/session?id=${sessionId}`, {
          responses,
          client_status: -1,
          mirats_status: 30,
        })
        .then((data) => {
          // console.log(data);
          window.location.href = `${
            window.location.origin
          }/7e08091a73b14e034889265e41ba796f91c766ad/${encodeURIComponent(
            ref_id,
          )}/40`;
        })
        .catch((er) => console.log(er));
    }
  };

  const handleZampliaRedirect = async ({
    url,
    surveyId,
    refId,
    responses = questionsData,
  }) => {
    try {
      const allDemographicQuery = responses
        ?.map((item) => item?.ZAMKey)
        ?.filter(Boolean)
        .join('&');
      // console.log('allDemographicQuery=>', allDemographicQuery);

      let body = {
        sessionID: sessionId,
        surveyId,
        refId,
        demographicQuery: allDemographicQuery,
      };
      const { data: zampliaRedirect } = await axios.post(
        `${BASE_URL}/redirect/get-zamplia-redirect`,
        body,
      );
      // console.log('zampliaRedirect=>', zampliaRedirect);
      const redirectTOURL = zampliaRedirect?.data?.URL;
      if (!redirectTOURL)
        throw new Error('Zamplia redirect URL is not available');
      // window.location.href = redirectTOURL + `&${allDemographicQuery}`;
      window.location.href = redirectTOURL;
      return;
    } catch (error) {
      console.log('Unable to perform zampliaRedirect redirects', error);
      await axios
        .put(`${BASE_URL}/session?id=${sessionId}`, {
          responses,
          client_status: -1,
          mirats_status: 30,
        })
        .then((data) => {
          // console.log(data);
          window.location.href = `${
            window.location.origin
          }/7e08091a73b14e034889265e41ba796f91c766ad/${encodeURIComponent(
            ref_id,
          )}/30`;
        })
        .catch((er) => console.log(er));
    }
  };

  const handlePureSpectrumRedirect = async ({
    surveyId,
    refId,
    responses = questionsData,
  }) => {
    try {
      const body = {
        surveyId,
        sessionId,
        refId,
        keys: responses?.map((item) => item?.PSKey),
      };

      const { data } = await axios.post(
        `${BASE_URL}/redirect/get-pure-spectrum-redirect`,
        body,
      );
      if (data?.success && data?.redirectURL) {
        window.location.href = data.redirectURL;
        return;
      }

      if (data?.reason === 'NO_SURVEY_AVAILABLE') {
        await axios.put(`${BASE_URL}/session?id=${sessionId}`, {
          responses,
          client_status: -1,
          mirats_status: 30,
        });

        window.location.href =
          `${window.location.origin}` +
          `/7e08091a73b14e034889265e41ba796f91c766ad/` +
          `${encodeURIComponent(ref_id)}/30`;

        return;
      }

      throw new Error(data?.message || 'PureSpectrum redirect failed');
    } catch (error) {
      console.error('Unable to perform PureSpectrum redirect', error);

      setSpinnerLoader(false);
      setResumingQualifications(false);
    }
  };
  // console.log({
  //   lastData: presecreenQuestions[currentIndex],
  //   currentData: questionsData[questionsData?.length - 1],
  // });
  const upsertQuestionResponse = (responses, response) => {
    return [
      ...responses.filter(
        (item) => item?.question_id !== response?.question_id,
      ),
      response,
    ];
  };

  const resumeQualifications = async (
    startIndex = 0,
    initialResponses = [],
  ) => {
    setSpinnerLoader(true);

    let responses = [...initialResponses];
    let activeIndex = startIndex;

    try {
      for (
        let index = startIndex;
        index < presecreenQuestions.length;
        index++
      ) {
        activeIndex = index;
        const question = presecreenQuestions[index];
        const cacheQuestionId = getQualificationCacheId(question);
        if (!cacheQuestionId) {
          setQuestionsData(responses);
          setCurrentIndex(index);
          setSpinnerLoader(false);
          setResumingQualifications(false);
          return;
        }
        let cached = null;
        try {
          cached = await getQualification(cacheQuestionId);
        } catch (error) {
          console.error('Unable to read qualification cache:', error);
          cached = null;
        }
        if (!cached) {
          setQuestionsData(responses);
          setCurrentIndex(index);
          setSpinnerLoader(false);
          setResumingQualifications(false);
          return;
        }

        const { response: cachedResponse, providerMappingValid } =
          buildCachedQuestionResponse(question, cached?.user_response);

        if (!providerMappingValid) {
          setQuestionsData(responses);
          setCurrentIndex(index);
          setSpinnerLoader(false);
          setResumingQualifications(false);
          return;
        }

        let validation;

        try {
          validation = await validateQualificationAnswer(
            question,
            cachedResponse,
          );
        } catch (error) {
          console.error('Unable to validate cached qualification:', error);

          // Fall back to asking this question manually.
          setQuestionsData(responses);
          setCurrentIndex(index);
          setSpinnerLoader(false);
          setResumingQualifications(false);
          return;
        }

        const nextResponses = upsertQuestionResponse(responses, cachedResponse);

        if (!validation.passed) {
          await terminateQualification({
            reason: validation.reason,
            responses: nextResponses,
          });

          return;
        }
        responses = nextResponses;
      }

      setQuestionsData(responses);

      await submitResponse(responses);
    } catch (error) {
      console.error('Unable to resume qualification flow:', error);

      setQuestionsData(responses);
      setCurrentIndex(activeIndex);
      setSpinnerLoader(false);
      setResumingQualifications(false);
    }
  };

  const checkIsAnswerCorrect = async (e, lastQuestion) => {
    e?.preventDefault();

    const currentQuestion = presecreenQuestions[currentIndex];
    const currentData = questionsData?.find(
      (data) => data?.question_id === currentQuestion?._id,
    );

    if (!currentData) {
      return;
    }

    setSpinnerLoader(true);
    let validation;

    try {
      validation = await validateQualificationAnswer(
        currentQuestion,
        currentData,
      );
    } catch (error) {
      console.error('Unable to validate qualification answer:', error);

      setSpinnerLoader(false);
      setResumingQualifications(false);
      return;
    }

    const nextResponses = upsertQuestionResponse(questionsData, currentData);

    if (!validation.passed) {
      await terminateQualification({
        reason: validation.reason,
        responses: nextResponses,
      });

      return;
    }

    const cacheQuestionId = getQualificationCacheId(currentQuestion);

    const cacheResponse = {
      questionName: currentQuestion?.question?.questionName,
      user_response: currentData?.user_response,
    };

    if (lastQuestion) {
      await submitResponse(
        nextResponses,
        cacheQuestionId
          ? {
              questionId: cacheQuestionId,
              response: cacheResponse,
            }
          : null,
      );

      return;
    }

    if (cacheQuestionId) {
      try {
        await saveQualification(cacheQuestionId, cacheResponse);
      } catch (error) {
        console.error('Unable to save qualification:', error);
      }
    }

    await resumeQualifications(currentIndex + 1, nextResponses);
  };
  // console.log('presecreenQuestions=>', presecreenQuestions);
  // console.log('currentQuestion', presecreenQuestions[currentIndex]);

  // console.log("lucidQuestions=>", lucidQuestions);
  // console.log(survey);
  // console.log('questionsData=>', questionsData);
  // console.log("hiddenPrescreeningQuestions=>", hiddenPrescreeningQuestions);
  return (
    <div className="h-[100dvh] relative">
      <div className="w-full h-[10px] bg-[#EAECF2]  rounded-[24px] ">
        <div
          style={{ width: `${calcProg}%` }}
          className={` bg-primary h-[10px]  rounded-[24px] myTransition`}
        >
          {/* <span>{calcProg}%</span> */}
        </div>
      </div>
      <div className="pt-[70px] h-full ipad:py-[44px]">
        <img
          src="https://miratsinsights.com/logo.svg"
          alt="logo"
          className="w-[160px] mx-[150px] ipad:ml-6"
        />
        <section className="mt-[80px] ipad:mt-[50px] pb-5">
          <form
            action=""
            onSubmit={(e) => {
              // console.log("qweoiuwqeo");
              e.preventDefault();
              // console.log("onSubmit");
              if (presecreenQuestions?.length - 1 !== currentIndex) {
                checkIsAnswerCorrect(e);
              } else {
                checkIsAnswerCorrect(e, true);
              }
            }}
          >
            {qualificationConfig?.error ? (
              <div className="mx-[150px] mt-[20px] tablet:mt-[50px] tablet:mx-[30px] ipad:mx-[24px] space-y-4">
                <h1 className="text-lg">Something went wrong..</h1>
              </div>
            ) : qualificationConfig?.loading || resumingQualifications ? (
              <div className="mx-[150px] mt-[20px] tablet:mt-[50px] tablet:mx-[30px] ipad:mx-[24px] space-y-4">
                <Skeleton className="w-[450px] h-[40px]" />
                <div className="space-y-3">
                  {[1, 2, 3, 4, 5]?.map((d) => (
                    <div key={d} className="flex items-center gap-4">
                      <Skeleton className="w-[30px] h-[30px] rounded-full" />
                      <Skeleton className="w-[140px] h-[30px]" />
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="">
                {presecreenQuestions?.map((element, index) => {
                  if (index === currentIndex) {
                    if (
                      element?.question?.questionType == 'Single Punch' ||
                      element?.question?.questionType == 'Dummy'
                    ) {
                      return SinglePunch({
                        element,
                        handleQuestionData,
                        questionsData,
                        setQuestionsData,
                        handlePrescreenEnter,
                      });
                    }
                    if (element?.question?.questionType === 'Text - Open-end') {
                      return TextEnd({
                        element,
                        handleQuestionData,
                        handlePrescreenEnter,
                      });
                    }
                    if (
                      element?.question?.questionType === 'Numeric - Open-end'
                    ) {
                      return NumericOpenEnd({
                        element,
                        handleQuestionData,
                        handlePrescreenEnter,
                      });
                    }
                    if (element?.question?.questionType === 'Multi Punch') {
                      return MultiPunch({
                        element,
                        handleQuestionData,
                        multiResponse,
                        setMultiResponse,
                        handleMultiResposnseChange,
                        handlePrescreenEnter,
                        questionsData,
                        setQuestionsData,
                      });
                    }
                  }
                })}
                <section className=" mx-[150px] mt-[20px] tablet:mt-[50px] tablet:mx-[30px] ipad:mx-[24px] submitQualificationContainer">
                  {spinnerLoader ? (
                    <LoaderBTN />
                  ) : presecreenQuestions?.length - 1 !== currentIndex ? (
                    <button
                      type="submit"
                      disabled={spinnerLoader}
                      className={`  px-4 py-3 text-white font-semibold rounded w-[118px] text-[14px] ${
                        spinnerLoader
                          ? 'cursor-not-allowed  bg-primary/40 hover:bg-[#1e64fb]'
                          : 'cursor-pointer  bg-primary hover:bg-[#1e64fb]'
                      }`}
                    >
                      Next{' '}
                    </button>
                  ) : (
                    <button
                      type="submit"
                      disabled={spinnerLoader}
                      className="bg-primary hover:bg-[#1e64fb] px-4 py-3 text-white font-semibold rounded w-[118px] text-[14px] "
                    >
                      Submit
                    </button>
                  )}
                </section>
              </div>
            )}
          </form>
        </section>
      </div>
    </div>
  );
};
const TextEnd = ({ element, handleQuestionData, handlePrescreenEnter }) => {
  // console.log("inside text");
  return (
    <div
      className="px-[150px] ipad:px-[24px] h-[65dvh] ipad:h-[55dvh]"
      key={element?._id}
    >
      <section className="flex flex-col gap-y-3 h-[50dvh] ipad:h-[45dvh]  overflow-y-auto ">
        <label htmlFor="age" className="text-[24px] font-[500] capitalize">
          {element?.question?.questionText}
        </label>
        <input
          type="text"
          name="age"
          onChange={(e) =>
            handleQuestionData(
              element?._id,
              element?.question?.questionName,
              e,
              element?.question || null,
            )
          }
          required
          className="border border-[#333] text-[14px] text-[#333] py-3 px-4 outline-none rounded w-[500px] textEnd ipad:w-[100%]"
        />
      </section>
    </div>
  );
};
const NumericOpenEnd = ({
  element,
  handleQuestionData,
  handlePrescreenEnter,
}) => {
  // console.log('inside numeric=>', element);
  return (
    <div
      className="px-[150px] ipad:px-[24px] h-[65dvh] ipad:h-[55dvh]"
      key={element?._id}
    >
      <section className="flex flex-col gap-y-3 h-[50dvh] ipad:h-[45dvh]  overflow-y-auto ">
        <label htmlFor="age" className="text-[24px] font-[500] capitalize">
          {element?.question?.questionText}
        </label>
        <input
          type="number"
          name="age"
          required
          className="border border-[#333] text-[14px] text-[#333] py-3 px-4 outline-none rounded w-[500px] textEnd ipad:w-[100%]"
          onChange={(e) =>
            handleQuestionData(
              element?._id,
              element?.question?.questionName,
              e,
              element?.question || null,
            )
          }
        />
      </section>
    </div>
  );
};
const SinglePunch = ({
  element,
  handleQuestionData,
  handlePrescreenEnter,
  questionsData,
  setQuestionsData,
}) => {
  const handleSingleChange = (qId, e, ind, data) => {
    // console.log("QID=>", qId, "Ind", ind);
    let newArr = [...questionsData]?.filter(
      (data) => data?.question_id !== qId,
    );
    const fullQuestion = element?.question;
    const createdBy = fullQuestion?.createdBy;
    const isTRquestion = createdBy === theoremReachId;
    const isZampliaquestion = createdBy === zampliaId;
    const isPSquestion = createdBy === pureSpectrumId;
    const clientQuestionID = fullQuestion.clientQuestionID || null;
    if (isTRquestion) {
      const answerID = fullQuestion?.optionIds[ind];
      newArr.push({
        question_id: qId,
        question_name: fullQuestion?.questionName,
        user_response: data,
        TRKey: clientQuestionID
          ? `question_${clientQuestionID}[]=${answerID}`
          : null,
      });
    } else if (isZampliaquestion) {
      const answerIDZAM = fullQuestion?.answerIds?.[ind];
      newArr.push({
        question_id: qId,
        question_name: fullQuestion?.questionName,
        user_response: data,
        ZAMKey: clientQuestionID ? `q${clientQuestionID}=${answerIDZAM}` : null,
      });
    } else if (isPSquestion) {
      const answerIDPS = fullQuestion?.answerIds?.[ind];
      newArr.push({
        question_id: qId,
        question_name: fullQuestion?.questionName,

        user_response: data,

        PSKey:
          clientQuestionID && answerIDPS != null
            ? `${clientQuestionID}=${answerIDPS}`
            : null,
      });
    } else {
      newArr.push({
        question_id: qId,
        question_name: fullQuestion?.questionName,
        user_response: data,
      });
    }
    setQuestionsData(newArr);
  };

  return (
    <div
      className="px-[150px] ipad:px-[24px] h-[65dvh] ipad:h-[55dvh]"
      key={element?._id}
    >
      <h1 className="mb-[39px] text-[24px] capitalize ipad:text-[20px] ">
        {element?.question?.questionText}
      </h1>
      <section className="flex flex-col gap-y-3 h-[50dvh] ipad:h-[40dvh]  overflow-y-auto singlePunchContainer">
        {element?.displayOptions?.map((data, index) => (
          <>
            <div className="flex items-center cursor-pointer singlePunchOption">
              <label className="container capitalize">
                {data}
                <input
                  type="radio"
                  // checked="checked"
                  required
                  name="singlePunch"
                  id={data}
                  onChange={(e) => {
                    handleSingleChange(element?._id, e, index, data);
                  }}
                />
                <span className="radio"></span>
              </label>
            </div>
          </>
        ))}
      </section>
    </div>
  );
};

const MultiPunch = ({
  element,
  handleQuestionData,
  multiResponse,
  setMultiResponse,
  handlePrescreenEnter,
  questionsData,
  setQuestionsData,
}) => {
  // console.log("multipunch");
  // console.log(element);
  // console.log(questionsData);
  // const handleMultiResposnseChange = (e, id, option, index) => {
  //   const fullQuestion = element?.question;
  //   const createdBy = fullQuestion?.createdBy;
  //   const isTRquestion = createdBy === theoremReachId;
  //   // const isZampliaquestion = createdBy === zampliaId;
  //   const clientQuestionID = fullQuestion.clientQuestionID || null;

  //   if (e.target.checked) {
  //     const answerID = fullQuestion?.optionIds?.[index];
  //     const answerIDZAM = fullQuestion?.answerIds?.[index];
  //     let singArr = questionsData?.filter((data) => data.question_id === id);
  //     // console.log("singleArr", singArr);
  //     if (singArr?.length) {
  //       if (!singArr[0].user_response.includes(option)) {
  //         singArr[0]?.user_response?.push(option);
  //         if (isTRquestion) {
  //           if (singArr[0]?.TRKey) {
  //             singArr[0].TRKey += `&question_${clientQuestionID}[]=${answerID}`;
  //           }
  //         }
  //         // if (isZampliaquestion) {
  //         //   if (singArr[0]?.ZAMKey) {
  //         //     singArr[0].ZAMKey += `&q${clientQuestionID}=${answerIDZAM}`;
  //         //   }
  //         // }
  //       }
  //     } else {
  //       if (isTRquestion) {
  //         singArr = [
  //           {
  //             question_id: id,
  //             question_name: element?.name,
  //             user_response: [option],
  //             TRKey: clientQuestionID
  //               ? `question_${clientQuestionID}[]=${answerID}`
  //               : null,
  //           },
  //         ];
  //       }
  //       //  else if (isZampliaquestion) {
  //       //   singArr = [
  //       //     {
  //       //       question_id: id,
  //       //       question_name: element?.name,
  //       //       user_response: [option],
  //       //       ZAMKey: clientQuestionID
  //       //         ? `q${clientQuestionID}=${answerIDZAM}`
  //       //         : null,
  //       //     },
  //       //   ];
  //       // }
  //       else {
  //         singArr = [
  //           {
  //             question_id: id,
  //             question_name: element?.name,
  //             user_response: [option],
  //           },
  //         ];
  //       }
  //       let newArr = [...questionsData, ...singArr];
  //       setQuestionsData(
  //         [...new Set(newArr?.map(JSON.stringify))].map(JSON.parse),
  //       );
  //     }
  //   } else {
  //     const answerID = fullQuestion?.optionIds?.[index];
  //     const answerIDZAM = fullQuestion?.answerIds?.[index];
  //     let singArr = questionsData?.filter((data) => data.question_id === id);
  //     let filtereRes = singArr[0]?.user_response?.filter(
  //       (data) => data !== option,
  //     );
  //     let filteredArray = questionsData?.filter(
  //       (data) => data.question_id !== id,
  //     );
  //     const filterKey = `question_${clientQuestionID}[]=${answerID}`;
  //     const updatedKey = singArr[0]?.TRKey?.split('&')
  //       .map((item) => item.trim())
  //       .filter((data) => data !== filterKey)
  //       .join('&');
  //     let finalArray = [
  //       ...filteredArray,
  //       {
  //         question_id: id,
  //         user_response: filtereRes,
  //         TRKey: isTRquestion && clientQuestionID ? updatedKey : null,
  //       },
  //     ];
  //     setQuestionsData(
  //       [...new Set(finalArray?.map(JSON.stringify))].map(JSON.parse),
  //     );
  //   }
  // };

  const handleMultiResposnseChange = (e, id, option, index) => {
    const fullQuestion = element?.question;
    const createdBy = fullQuestion?.createdBy;

    const isTRquestion = createdBy === theoremReachId;
    const isZampliaquestion = createdBy === zampliaId;
    const isPSquestion = createdBy === pureSpectrumId;

    const clientQuestionID = fullQuestion?.clientQuestionID || null;

    const answerID = fullQuestion?.optionIds?.[index];
    const answerIDZAM = fullQuestion?.answerIds?.[index];

    const existingQuestion = questionsData?.find(
      (data) => data.question_id === id,
    );

    const buildPSKey = (responses) => {
      if (!isPSquestion || !clientQuestionID || !Array.isArray(responses)) {
        return null;
      }

      const answerIds = responses
        .map((response) => {
          const optionIndex = element?.displayOptions?.findIndex(
            (option) => String(option).trim() === String(response).trim(),
          );

          if (optionIndex == null || optionIndex < 0) {
            return null;
          }

          return fullQuestion?.answerIds?.[optionIndex];
        })
        .filter((answerId) => answerId != null)
        .map(String);

      return answerIds.length
        ? `${clientQuestionID}=${answerIds.join(',')}`
        : null;
    };

    if (e.target.checked) {
      if (existingQuestion) {
        const updatedResponses = existingQuestion.user_response.includes(option)
          ? existingQuestion.user_response
          : [...existingQuestion.user_response, option];

        let updatedTRKey = existingQuestion.TRKey;
        let updatedZAMKey = existingQuestion.ZAMKey;
        const updatedPSKey = buildPSKey(updatedResponses);

        if (isTRquestion && clientQuestionID) {
          updatedTRKey = updatedTRKey
            ? `${updatedTRKey}&question_${clientQuestionID}[]=${answerID}`
            : `question_${clientQuestionID}[]=${answerID}`;
        }

        if (isZampliaquestion && clientQuestionID) {
          const existingZAMIds = updatedZAMKey
            ? updatedZAMKey.split('=')[1]?.split(',').filter(Boolean)
            : [];

          if (!existingZAMIds.includes(String(answerIDZAM))) {
            existingZAMIds.push(String(answerIDZAM));
          }
          updatedZAMKey = `q${clientQuestionID}=${existingZAMIds.join(',')}`;
        }

        const updatedQuestion = {
          ...existingQuestion,
          user_response: updatedResponses,
          ...(isTRquestion && { TRKey: updatedTRKey }),
          ...(isZampliaquestion && { ZAMKey: updatedZAMKey }),
          ...(isPSquestion && { PSKey: updatedPSKey }),
        };

        setQuestionsData(
          questionsData.map((data) =>
            data.question_id === id ? updatedQuestion : data,
          ),
        );
      } else {
        const newQuestion = {
          question_id: id,
          question_name: element?.question?.questionName || element?.name,
          user_response: [option],
          ...(isTRquestion && {
            TRKey: clientQuestionID
              ? `question_${clientQuestionID}[]=${answerID}`
              : null,
          }),
          ...(isZampliaquestion && {
            ZAMKey: clientQuestionID
              ? `q${clientQuestionID}=${answerIDZAM}`
              : null,

            ...(isPSquestion && {
              PSKey: updatedPSKey,
            }),
          }),
        };
        setQuestionsData([...questionsData, newQuestion]);
      }
    } else {
      if (!existingQuestion) return;
      const updatedResponses = existingQuestion.user_response.filter(
        (data) => data !== option,
      );
      let updatedTRKey = existingQuestion.TRKey;
      let updatedZAMKey = existingQuestion.ZAMKey;
      const updatedPSKey = buildPSKey(updatedResponses);

      if (isTRquestion && clientQuestionID) {
        const filterKey = `question_${clientQuestionID}[]=${answerID}`;
        updatedTRKey = updatedTRKey
          ?.split('&')
          .filter((item) => item !== filterKey)
          .join('&');
      }

      if (isZampliaquestion && clientQuestionID) {
        const existingZAMIds = updatedZAMKey
          ? updatedZAMKey.split('=')[1]?.split(',').filter(Boolean)
          : [];

        const updatedZAMIds = existingZAMIds.filter(
          (id) => id !== String(answerIDZAM),
        );

        updatedZAMKey = updatedZAMIds.length
          ? `q${clientQuestionID}=${updatedZAMIds.join(',')}`
          : null;
      }
      if (updatedResponses.length === 0) {
        setQuestionsData(
          questionsData.filter((data) => data.question_id !== id),
        );
        return;
      }

      const updatedQuestion = {
        ...existingQuestion,
        user_response: updatedResponses,
        ...(isTRquestion && { TRKey: updatedTRKey }),
        ...(isZampliaquestion && { ZAMKey: updatedZAMKey }),
        ...(isPSquestion && { PSKey: updatedPSKey }),
      };

      setQuestionsData(
        questionsData.map((data) =>
          data.question_id === id ? updatedQuestion : data,
        ),
      );
    }
  };

  return (
    <div
      className="px-[150px] ipad:px-[24px] h-[65dvh] ipad:h-[55dvh]"
      key={element?._id}
    >
      <h1 className="mb-[39px] text-[24px] ipad:text-[20px] capitalize">
        {element?.question?.questionText}
      </h1>
      <section className="flex flex-col gap-y-3 h-[45dvh] ipad:h-[40dvh]  overflow-y-auto singlePunchContainer">
        {element?.displayOptions?.map((option, index) => (
          <>
            <div className="flex cursor-pointer multiPunchOption">
              <label className="containerCheck capitalize">
                {option}
                <input
                  type="checkbox"
                  id={index}
                  required={
                    !questionsData?.some(
                      (cData) =>
                        cData?.question_id == element?._id &&
                        cData?.user_response?.length >= 1,
                    )
                  }
                  name="multiPunch"
                  value={option}
                  onChange={(e) =>
                    handleMultiResposnseChange(e, element?._id, option, index)
                  }
                />
                <span className="check"></span>
              </label>
            </div>
          </>
        ))}
      </section>
    </div>
  );
};

export default SurveyQualification;
